module.exports = __webpack_public_path__ + "images/emoji/floppy_disk.31dc2eb32586995c6806.png";